import React from 'react'
import Markdown from 'react-markdown'
import { PluggableList } from 'react-markdown/lib'

import { CLink } from '@coreui/react-pro'
import { CLinkProps } from '@coreui/react-pro/dist/components/link/CLink'
import rehypeRaw from 'rehype-raw'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import { IMarkDownConverter } from '@interfaces/components/molecules/MarkDownConverter'

import './styles.scss'

const MarkDownConverter: React.FC<IMarkDownConverter> = ({ value, className }) => {
  return (
    <Markdown
      className={`MDCContainer ${className}`}
      remarkPlugins={[remarkGfm, remarkBreaks]}
      rehypePlugins={[rehypeRaw] as PluggableList}
      components={{
        a(props) {
          const { ...rest } = props as CLinkProps
          return <CLink target="_blank" {...rest} />
        },
      }}
    >
      {value}
    </Markdown>
  )
}

export default MarkDownConverter
